import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-775bd9b3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "swiperbox"
};
import { ref } from 'vue';
import { Swiper } from 'swiper/vue'; // swiper 所需组件
import { Autoplay, Navigation, Pagination, A11y } from 'swiper'; // 分页器
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// navigation boolean 是否显示分页器

export default {
  __name: 'index',
  props: {
    slidesPerView: Number | String,
    autoplay: {
      type: Boolean,
      default: true
    },
    navigation: {
      type: Boolean,
      default: true
    },
    // 是否添加hover 控制
    controll: {
      type: Boolean,
      default: false
    },
    // 偏移量
    slidesOffsetBefore: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const controlledSwiper = ref(null);
    const setControlledSwiper = swiper => {
      controlledSwiper.value = swiper;
    };
    let centered = true;
    let modules = [Autoplay, Pagination, Navigation, A11y];
    if (!props.autoplay) {
      modules = [];
      centered = false;
    }
    const mouseOver = () => {
      if (props.controll) {
        controlledSwiper.value.autoplay.stop();
      }
    };
    const mouseOut = () => {
      if (props.controll) {
        controlledSwiper.value.autoplay.start();
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Swiper), {
        slidesPerView: props.slidesPerView,
        spaceBetween: 0,
        loop: true,
        centeredSlides: _unref(centered),
        pagination: {
          clickable: true
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        navigation: props.navigation,
        modules: _unref(modules),
        onSwiper: setControlledSwiper,
        onMouseover: _cache[0] || (_cache[0] = $event => mouseOver()),
        slidesOffsetBefore: props.slidesOffsetBefore,
        onMouseout: _cache[1] || (_cache[1] = $event => mouseOut())
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["slidesPerView", "centeredSlides", "navigation", "modules", "slidesOffsetBefore"])]);
    };
  }
};